import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _796f155e = () => interopDefault(import('../pages/contact-for-schools.vue' /* webpackChunkName: "pages/contact-for-schools" */))
const _01f68336 = () => interopDefault(import('../pages/locker.vue' /* webpackChunkName: "pages/locker" */))
const _5ac99fc6 = () => interopDefault(import('../pages/registration.vue' /* webpackChunkName: "pages/registration" */))
const _1535fd3a = () => interopDefault(import('../pages/unsubscribe-successful.vue' /* webpackChunkName: "pages/unsubscribe-successful" */))
const _0e81571e = () => interopDefault(import('../pages/continue-order/_order_id.vue' /* webpackChunkName: "pages/continue-order/_order_id" */))
const _3d7bf2f6 = () => interopDefault(import('../pages/payment-failed/_failed_payment_id.vue' /* webpackChunkName: "pages/payment-failed/_failed_payment_id" */))
const _76e1fc8b = () => interopDefault(import('../pages/payment-successful/_successful_payment_id.vue' /* webpackChunkName: "pages/payment-successful/_successful_payment_id" */))
const _72b5ba06 = () => interopDefault(import('../pages/registration-successful/_successful_registration_id.vue' /* webpackChunkName: "pages/registration-successful/_successful_registration_id" */))
const _6e09efe2 = () => interopDefault(import('../pages/subscription-renewal/_subscription_renewal_id.vue' /* webpackChunkName: "pages/subscription-renewal/_subscription_renewal_id" */))
const _5557d9d6 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _58c51c66 = () => interopDefault(import('../pages/_slug.vue' /* webpackChunkName: "pages/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/contact-for-schools",
    component: _796f155e,
    name: "contact-for-schools___hu___default"
  }, {
    path: "/contact-for-schools",
    component: _796f155e,
    name: "contact-for-schools___hu"
  }, {
    path: "/locker",
    component: _01f68336,
    name: "locker___hu___default"
  }, {
    path: "/locker",
    component: _01f68336,
    name: "locker___hu"
  }, {
    path: "/registration",
    component: _5ac99fc6,
    name: "registration___hu___default"
  }, {
    path: "/registration",
    component: _5ac99fc6,
    name: "registration___hu"
  }, {
    path: "/unsubscribe-successful",
    component: _1535fd3a,
    name: "unsubscribe-successful___hu___default"
  }, {
    path: "/unsubscribe-successful",
    component: _1535fd3a,
    name: "unsubscribe-successful___hu"
  }, {
    path: "/continue-order/:order_id?",
    component: _0e81571e,
    name: "continue-order-order_id___hu___default"
  }, {
    path: "/continue-order/:order_id?",
    component: _0e81571e,
    name: "continue-order-order_id___hu"
  }, {
    path: "/payment-failed/:failed_payment_id",
    component: _3d7bf2f6,
    name: "payment-failed-failed_payment_id___hu___default"
  }, {
    path: "/payment-failed/:failed_payment_id",
    component: _3d7bf2f6,
    name: "payment-failed-failed_payment_id___hu"
  }, {
    path: "/payment-successful/:successful_payment_id",
    component: _76e1fc8b,
    name: "payment-successful-successful_payment_id___hu___default"
  }, {
    path: "/payment-successful/:successful_payment_id",
    component: _76e1fc8b,
    name: "payment-successful-successful_payment_id___hu"
  }, {
    path: "/registration-successful/:successful_registration_id?",
    component: _72b5ba06,
    name: "registration-successful-successful_registration_id___hu___default"
  }, {
    path: "/registration-successful/:successful_registration_id?",
    component: _72b5ba06,
    name: "registration-successful-successful_registration_id___hu"
  }, {
    path: "/subscription-renewal/:subscription_renewal_id",
    component: _6e09efe2,
    name: "subscription-renewal-subscription_renewal_id___hu___default"
  }, {
    path: "/subscription-renewal/:subscription_renewal_id",
    component: _6e09efe2,
    name: "subscription-renewal-subscription_renewal_id___hu"
  }, {
    path: "/",
    component: _5557d9d6,
    name: "index___hu___default"
  }, {
    path: "/",
    component: _5557d9d6,
    name: "index___hu"
  }, {
    path: "/:slug",
    component: _58c51c66,
    name: "slug___hu___default"
  }, {
    path: "/:slug",
    component: _58c51c66,
    name: "slug___hu"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
